import { HTTP } from '../config/http-common';
import { ROUTE_API } from '../constants/routes';
import { exportResults, convertParams } from '../utils/index';

export const upload = async (payload, size = 500) => {
    return exportResults(await HTTP.post(`${ROUTE_API.UPLOAD_IMAGE}/${size}`, payload));
};
